import React from "react";
import { Button, Tooltip } from "@mui/material";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

export default function CustomizedDialogs(props) {

  return (
    <div>
      <Tooltip title="Tips" arrow>
        <Button
          sx={{
            mx: 0.5,
            height: { xs: "26px", sm: "30px" },
            width: { xs: "26px", sm: "30px" },
            minWidth: 'auto',
            marginBottom: { xs: "3px", sm: "5px" },
            marginTop: { xs: "-18px", sm: "-20px" },
            borderRadius: '50px',
            boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
            p: 0,
          }}
          variant="contained"
          component="a"
          target="_blank"
          rel="noopener noreferrer"
          href={process.env.REACT_APP_GUDELINE_URL}
          aria-label="open tips"
        >
          <OpenInNewIcon sx={{ fontSize: { xs: "1rem", sm: "1.1rem" } }} />
        </Button>
      </Tooltip>
    </div>
  );
}
